import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c379a76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import  {minuteCalc as mc}  from '@/logic/_infra/time'




export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceControl',
  props: {
    value: {},
    showZeroBalance: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_ctx.value != 0 || _ctx.showZeroBalance)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass({ 'red': _ctx.value < 0, 'blue': _ctx.value > 0 })
        }, [
          (_ctx.value > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("+")
              ], 64))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(mc).toAproximatedHoursString(_ctx.value)), 1)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})